// extracted by mini-css-extract-plugin
export var phone = "_4d-0";
export var phoneDragging = "_4d-1";